import React from 'react'
import './Home.css'
import Card from './Card/Card'
import { Link } from 'react-router-dom'
import { useState,useEffect } from 'react'
import { Doc_Counter } from '../../../firebase/utils'


const Home = () => {

    const [ProdCount,setProdcount]=useState('0')
    const [CustomerCount,setCustomercount]=useState('0')
    
    const [UsersCount,setUserscount]=useState('0')
     const [AnalyseCount,setAnalysecount]=useState('0')
    const [PurchasesCount,setPurchasescount]=useState('0')
    const [MessagesCount,setMessagescount]=useState('0')

  useEffect (
    ()=>{
      Doc_Counter('Produits',setProdcount)
       Doc_Counter('Users',setUserscount)
      Doc_Counter('Customers',setCustomercount)
      Doc_Counter('Purchases',setPurchasescount)

    },[]
  )





  return (
    <div id='HomePage' className='FadeIn'>
      
      <Link to={'../ProductsMenu/Products'}style={{textDecoration:'none'}}>
        <Card number={ProdCount} text={'Produits Enregistrés'} notice={"ce mois"} second_info={'Cliquez pour voir la liste des produits'} colorbottom={'#65052e'}  colortop={'#ff4566'}/>
      </Link>
      <Link to={'../Purchases'}style={{textDecoration:'none'}}>
        <Card number={PurchasesCount} text={'Commandes en cours'} notice={'ce mois'} second_info={'Cliquez pour voir la liste des Commandes'} colorbottom={'#992626'} colortop={'#FF3F3F'}   />
      </Link>
      <Link to={'../Customers'}style={{textDecoration:'none'}}>
        <Card number={CustomerCount} text={'Clients'} notice={'ce mois'} second_info={'Cliquez pour voir la liste des Clients'} colorbottom={'#053C53'} colortop={'#0C85B9'}/>
      </Link>

      <Link to={'../Analytics'}style={{textDecoration:'none'}}>
        <Card number={AnalyseCount} text={"Rapports d'analyses"} notice={'ce mois'} second_info={"Cliquez pour voir les rapports complets"} colorbottom={'#774900'} colortop={'#DD8800'}/>
      </Link>
      <Link to={'../Analytics'} style={{textDecoration:'none'}}>
        <Card number={MessagesCount} text={"Messages clients non lus"} notice={'ce mois'} second_info={"Cliquez pour voir les messages"} colorbottom={'#2A5F0D'} colortop={'#56C51B'}/>
      </Link>
      <Link to={'../Analytics'} style={{textDecoration:'none'}}>
        <Card number={UsersCount} text={"Employés en ligne"} notice={'actuellement'} second_info={"Cliquez pour voir les employés connectés"} colorbottom={'#65052e'}  colortop={'#ff4566'}/>
      </Link>
    </div>
  )
}

export default Home